import { Box, Typography, Paper, CircularProgress, Alert, Container } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PaymentCancelPage = () => {
   
    return (
        <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
            <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, textAlign: 'center' }}>
                <>
                    <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />
                    <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
                        Payment Cancelled
                    </Typography>
                </>
            </Paper>
        </Container>
    );
};

export default PaymentCancelPage;